import React, {useContext, useEffect} from 'react'
import styled from '@emotion/styled'
import {graphql} from 'gatsby'
import {mapEdgesToNodes} from '../lib/helpers'
import BlogPostPreviewGrid from '../components/blog-post-preview-grid'
import GraphQLErrorList from '../components/graphql-error-list'
import SEO from '../components/seo'
import { globalHistory as history } from '@reach/router'


import Layout from '../components/layout'



//import { ThemeContext } from '../context/themeContext'
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from '../context/globalContextProvider'


import theme from '../utils/theme';
import {CommonMargins} from '../utils/styles'

const PageWrap = styled('div')`
/*
  padding-top: 80px;

  @media ${theme.breakpoints.md} { 
    padding-top: 120px;
  }
*/
`

// import {responsiveTitle1} from '../components/typography.module.css'


export const query = graphql`
  query ArchivePageQuery {
    posts: allSanityPost(
      sort: {publishedAt: DESC}
      filter: {slug: {current: {ne: null}}, publishedAt: {ne: null}}
      ) {
      edges {
        node {
          id
          publishedAt
          title
          _rawBody(resolveReferences: {maxDepth: 5})
          slug {
            current
          }
        }
      }
    }
  }
`


const ArchivePage = (props) => {
  const {
    data,
    errors,
    setNewsTitles,
    setHideStatusContainer,
    setSection,
    setRef
  } = props.pageProps || props

  const state = useContext(GlobalStateContext) || {}

  const dispatch = useContext(GlobalDispatchContext)
  useEffect(() => {
    dispatch({ 
      type: 'setTheme',
      value: 'orange',
    })
  }, []);

  const { location, navigate } = history

  useEffect(() => {
    setSection(location.pathname)
  }, []);


  // Status container is not present on News Page
  useEffect(() => {
    setHideStatusContainer(true)
  }, [])


  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    )
  }

  // console.log(props.pageProps)

  const postNodes = data && data.posts && mapEdgesToNodes(data.posts)

  return (
    <>
      <SEO title='News' />

      <PageWrap>
        {postNodes && postNodes.length > 0 && <BlogPostPreviewGrid nodes={postNodes} setNewsTitles={setNewsTitles} setRef={setRef} />}
      </PageWrap>
    </>
  )
}

export default ArchivePage
